/* eslint-disable max-len */
import { ShadowContainer as StyledShadowContainer } from './ShadowContainer.styles';
import * as React from 'react';

export interface ShadowContainerProps {
  /**
   * Is the user logged in?
   */
  loggedIn?: boolean;
  /**
   * Optional children React Components.
   */
  children?: React.ReactNode;
  setMinHeight?: boolean;
}

/**
 * This container is used in Open Reporting both in the question flow and when the user is logged in. On Desktop, it has a set height and width, and on Mobile the container responsively takes up the entire width and height of the screen.
 */
export const ShadowContainer: React.FC<ShadowContainerProps> = ({
  loggedIn = false,
  setMinHeight = true,
  children,
}: ShadowContainerProps) => {
  return (
    <StyledShadowContainer loggedIn={loggedIn} setMinHeight={setMinHeight}>
      {children}
    </StyledShadowContainer>
  );
};

export default ShadowContainer;
